import { photoLayoutConfig } from '~/components/photoLayoutConfig';
import { PhotoLayout } from './PhotoLayout';

export function WindshieldPhoto() {
  return <PhotoLayout {...photoLayoutConfig['windshield']} />;
}
